var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InView',{staticClass:"blade",style:(_vm.sectionStyles),attrs:{"noProgressEvents":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var progress = ref.progress;
var sectionOnScreen = ref.onScreen;
return [_c('h2',[_vm._v(_vm._s(_vm.config.headline))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.config.sub)}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }